export const CLEAR_DASHBOARD_ORDERS = 'CLEAR_DASHBOARD_ORDERS'
export const SET_DASHBOARD_ORDERS = 'SET_DASHBOARD_ORDERS'

export const clearDashboardOrders = () => ({ type: CLEAR_DASHBOARD_ORDERS })
export const setDashboardOrders = (orders) => ({
  type: SET_DASHBOARD_ORDERS,
  orders,
})
